import immutable from 'immutable';
import { OPERATION_STATUS } from 'util/config/constant';
import {
  INITIAL_MACHINE_INFO,
  INITIAL_MACHINE_SUGGESTIONS
} from '../util/constant';
import * as actions from './action';

export const initialMachineDetailsInformationData = INITIAL_MACHINE_INFO;
export const initialMachineSuggestions = INITIAL_MACHINE_SUGGESTIONS;

export const init = () => {
  const initValue = immutable.fromJS({
    machineInformation: undefined,
    delete: undefined,
    machineSuggestions: undefined
  });

  return initValue
    .set('machineInformation', {
      data: { ...initialMachineDetailsInformationData },
      isLoading: false
    })
    .set('delete', {
      isLoading: false,
      status: OPERATION_STATUS.DEFAULT
    })
    .set('machineSuggestions', {
      data: { ...initialMachineSuggestions },
      isLoading: false
    })
    .set('updateGeofence', {
      isLoading: false,
      status: OPERATION_STATUS.DEFAULT
    });
};

export default function machineDetailsReducer(state = init(), action) {
  switch (action.type) {
    case actions.GET_MACHINE_DETAILS_INFORMATION_REQUEST:
      return state.update('machineInformation', (machineInformation) => ({
        ...machineInformation,
        isLoading: true
      }));

    case actions.GET_MACHINE_DETAILS_INFORMATION_SUCCESS: {
      const { payload } = action;

      return state.update('machineInformation', (machineInformation) => {
        return {
          ...machineInformation,
          isLoading: false,
          data: payload || {} // fallback for non-existing machine
        };
      });
    }

    case actions.GET_MACHINE_DETAILS_INFORMATION_FAIL:
      return state.update('machineInformation', (machineInformation) => ({
        ...machineInformation,
        isLoading: false
      }));

    case actions.UPDATE_MACHINE_DETAILS_REQUEST:
      return state.update('machineInformation', (machineInformation) => ({
        ...machineInformation,
        isLoading: true
      }));

    case actions.UPDATE_MACHINE_DETAILS_SUCCESS: {
      const patchedFields = action.payload;

      return state.update('machineInformation', (machineInformation) => {
        return {
          ...machineInformation,
          isLoading: false,
          data: {
            ...machineInformation.data,
            ...patchedFields
          }
        };
      });
    }

    case actions.UPDATE_MACHINE_DETAILS_FAIL:
      return state.update('machineInformation', (machineInformation) => ({
        ...machineInformation,
        isLoading: false
      }));

    case actions.LIST_MACHINE_SUGGESTION_REQUEST:
      return state.update('machineSuggestions', (machineSuggestions) => ({
        ...machineSuggestions,
        isLoading: true
      }));

    case actions.LIST_MACHINE_SUGGESTION_SUCCESS: {
      const { payload } = action;

      return state.update('machineSuggestions', (machineSuggestions) => {
        return {
          ...machineSuggestions,
          isLoading: false,
          data: payload
        };
      });
    }

    case actions.DELETE_MACHINE_REQUEST:
      return state.update('delete', () => ({
        isLoading: true,
        status: OPERATION_STATUS.DEFAULT
      }));

    case actions.DELETE_MACHINE_SUCCESS: {
      return state.update('delete', () => ({
        isLoading: false,
        status: OPERATION_STATUS.SUCCESS
      }));
    }

    case actions.DELETE_MACHINE_FAIL: {
      return state.update('delete', () => ({
        isLoading: false,
        status: OPERATION_STATUS.FAIL
      }));
    }

    case actions.LIST_MACHINE_SUGGESTION_FAIL:
      return state.update('machineSuggestions', (machineSuggestions) => ({
        ...machineSuggestions,
        isLoading: false
      }));

    case actions.UPDATE_MACHINE_GEOFENCE_REQUEST:
      return state.update('updateGeofence', (data) => ({
        ...data,
        isLoading: true,
        status: OPERATION_STATUS.DEFAULT
      }));

    case actions.UPDATE_MACHINE_GEOFENCE_SUCCESS:
      return state.update('updateGeofence', (data) => ({
        ...data,
        isLoading: false,
        status: OPERATION_STATUS.SUCCESS
      }));

    case actions.UPDATE_MACHINE_GEOFENCE_FAIL:
      return state.update('updateGeofence', (data) => ({
        ...data,
        isLoading: false,
        status: OPERATION_STATUS.FAIL
      }));

    case actions.RESET_MY_MACHINE_DETAILS_STATE:
      return init();

    default:
      return state;
  }
}
